<template>
    <div class="search">
        <!-- 1. 搜索框 -->
        <div class="search-layout-title-bar dsp-flex">
            <div class="title-side title-left" @click="clickBack">
                <i class="iconfont icon-guanbi"></i>
            </div>
            <div class="title-middle">
                <search-input 
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
            <div class="title-side title-green" @click="clickSearch">搜索</div>
        </div>

        <div v-if="searchResultList.length == 0" class="search-layout-content">
            <!-- 2. 选择栏 -->
            <search-select-box></search-select-box>

            <!-- 3. 高级搜索 -->
            <div class="search-title-note">高级搜索</div>
            <div class="search-high-list dsp-flex">
                <div class="search-high-item" @click="clickAdvanced('ganzhi')">
                    <span class="search-high-icon search-high-icon-gz"></span>
                    <p>干支搜索</p>
                </div>
                <div class="search-high-item" @click="clickAdvanced('wuxing')">
                    <span class="search-high-icon search-high-icon-wx"></span>
                    <p>五行搜索</p>
                </div>
                <div class="search-high-item" @click="clickLabel">
                    <span class="search-high-icon search-high-icon-label"></span>
                    <p>标签搜索</p>
                </div>
            </div>
        </div>

        <!-- 4. 搜索结果显示 -->
        <div v-if="searchResultList.length > 0" class="search-result-list">
            <virtual-list id="SearchList" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="searchResultList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'com-record-item-w90'" />
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import SearchInput from '../components/SearchInput.vue'
import SearchSelectBox from "../layouts/search/SearchSelectBox.vue";
import SearchResultItem from '../components/search/SearchResultItem.vue'
import { DOM, SEARCH_DOM } from '../modules/dom';
export default {
    name: 'Search',
    components: { SearchInput, SearchSelectBox },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchSelectedData() {
            return this.$store.state.search.searchSelectedData;
        },
        searchResultList() {
            return this.$store.state.search.searchResultList;
        }
    },
    data() {
        return {
            searchInputId: 'searchInput',
            itemComponent: SearchResultItem
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            me.$el.style.minHeight = (innerHeight-40) + 'px';
            SEARCH_DOM.updateSearchPageStyle();
        }, 100);
    },
    created: function() {
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
    },
    methods: {
        clickBack() {
            this.$store.dispatch('search/resetData');
            this.$router.replace('/record');
            this.$store.state.search.searchSelectedData = Object.assign({situation: 0, sex: -1, age: 0});
            var me = this;
            setTimeout(() => {
                me.$store.dispatch('record/updateRecordFilterList');
            }, 20);
        },
        inputSearch(word) {
            this.$store.state.search.searchData.searchText = word;
            if(word != ''){
                this.$store.dispatch('search/confirmSearchInput', word);
            }else{
                this.$store.state.search.searchResultList = [];
            }
            setTimeout(() => {
                SEARCH_DOM.updateSearchPageStyle();
            }, 20);
        },
        clickSearch() {
            var word = this.$store.state.search.searchData.searchText;
            if(word == ''){
                if(this.searchSelectedData.situation == 0 && this.searchSelectedData.sex == -1) {
                    // 如果没有搜索条件
                    this.$toast('请选择搜索条件')
                }else{
                    this.$store.dispatch('search/confirmSearchInput', '');
                    this.$store.state.search.searchResultFromPage = 'search';
                    this.$router.replace('/search/result');
                    DOM.setHiddenByClassName('search-layout-content');
                }
            }
        },
        clickAdvanced(type) {
            if(type == 'ganzhi') {
                window._czc.push(["_trackEvent", "搜索模块", "搜索", "干支搜索"]);
            }else if(type == 'wuxing') {
                window._czc.push(["_trackEvent", "搜索模块", "搜索", "五行搜索"]);
            }
            this.$router.replace('/search/advanced');
            this.$store.dispatch('search/resetData');
            this.$store.state.search.advancedType = type;
        },
        clickLabel() {
            this.$store.dispatch('label/resetData');
            this.$store.dispatch('search/resetData');
            this.$router.replace('/search/label');
        }
    }
}
</script>